<template lang="pug">
  .usuarios.container.grid-lg.py-2
    loading.v-loading(:loading='loading')
    .usuario
      .card(v-if='perfil')
        .card-body
          .form-group
            label.form-label(for='descricao') {{ 'perfil.descricao' | tModel }}
            input.form-input#descricao(type='text' v-model='perfil.descricao')
          .form-group(v-if='tree && tree.permissoes')
            label.form-label {{ 'perfil.permissoes' | tModel }}
            .has-icon-left(style='max-width: 400px;')
              input.form-input.input-sm#query(type='search' v-model='query' placeholder='Pesquisar permissões')
              i.form-icon.fa.fa-search
            .text-right(style='padding-right: 20px;')
              a.btn.btn-link.tooltip.tooltip-bottom(@click='toggle(true)' data-tooltip='Expandir')
                i.fa.fa-lg.fa-plus-circle.primary
              a.btn.btn-link.tooltip.tooltip-bottom(@click='toggle(false)' data-tooltip='Recolher')
                i.fa.fa-lg.fa-minus-circle.primary
            permissoes(:permissoes='tree.permissoes', :query='query')
        .card-footer.text-right
          button.btn.btn-primary(:class="{'loading': loading}", @click='save', :disabled='loading')
            btn-content(name='save')
</template>

<script>
import Perfil from '@/models/Perfil'
import Permissao from '@/models/Permissao'

export default {
  vuex: {
    'sistema/perfis': {
      state: ['todasAsPermissoes'],
      actions: ['fetchCreate', 'fetchTodasAsPermissoes'],
      getters: ['loading'],
    },
  },
  data() {
    return { perfil: new Perfil(), query: '', tree: {} }
  },
  methods: {
    toggle(value) {
      if (this.tree) {
        this.tree.toggleAll(value)
      }
    },
    save() {
      this.perfil.permissoes = this.tree.json
      this.fetchCreate(this.perfil)
        .then(res => {
          this.$toaster.success('Salvo com sucesso.')
          this.$router.push({ name: 'app.sistema.perfis' })
        })
        .catch(e => {
          this.$toaster.error(this.$parseErrors(e).join(', '))
        })
    },
    setTree() {
      this.tree = new Permissao(this.todasAsPermissoes, this.perfil.permissoes)
    },
  },

  created() {
    if (this.todasAsPermissoes) {
      this.setTree()
    } else {
      this.fetchTodasAsPermissoes().then(this.setTree)
    }
  },
}
</script>
